import React, { ReactNode, useEffect } from 'react';
import { useAuthContext } from './AuthContext';

interface RequireAuthProps {
  children: ReactNode;
}

const RequireAuth = ({ children }: RequireAuthProps) => {
  const auth = useAuthContext();

  useEffect(() => {
    console.log('RequireAuth - Auth state:', {
      isLoading: auth.isLoading,
      isAuthenticated: auth.isAuthenticated,
      user: auth.user,
      error: auth.error
    });

    if (!auth.isAuthenticated && !auth.isLoading) {
      console.log('RequireAuth - Calling signinRedirect');
      auth.signinRedirect().catch(error => {
        console.error('signinRedirect failed:', error);
      });
    }
  }, [auth.isAuthenticated, auth.isLoading]);

  if (auth.isLoading) {
    console.log('RequireAuth - Showing loading spinner');
    return <div className="flex items-center justify-center h-screen">
      <div className="w-20 h-20 border-[6px] border-gray-300 border-t-textPrimary rounded-full animate-spin" />
    </div>;
  }

  if (!auth.isAuthenticated) {
    console.log('RequireAuth - Not authenticated, showing loading');
    return <div className="flex items-center justify-center h-screen">
      <div className="w-20 h-20 border-[6px] border-gray-300 border-t-textPrimary rounded-full animate-spin" />
    </div>;
  }

  return <>{children}</>;
};

export default RequireAuth;
